import { useState } from 'react'
import { useAuth } from '../../hooks/AuthContext'
import changeUsePassword from '../../apis/changeUsePassword'
import lock from '../../assets/icons/lock.svg'
import eye from '../../assets/icons/eyeBlack.svg'
import eyel from '../../assets/icons/closedEye.svg'

const Security = () => {
  const [loading, setLoading] = useState(false)
  const [showCurrent, setshowCurrent] = useState(false)
  const [showNew, setshowNew] = useState(false)
  const [showConfirmation, setshowConfirmation] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const { user } = useAuth()

  const [userData, setUserData] = useState({
    id: user.user_id,
    currentPassword: '',
    newPassword: '',
    newPassword_confirmation: '',
  })
  const handleChangePasswod = async (e) => {
    e.preventDefault()

    if (userData.newPassword !== userData.newPassword_confirmation) {
      setError('passwords does not match')
      return
    }
    try {
      setLoading(true)
      await changeUsePassword(userData)
      setSuccess('password Changed successfully')
    } catch (error) {
      console.log(error)
      setError(error.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = (e) => {
    setError('')
    const { name, value } = e.target
    setUserData((prevData) => ({ ...prevData, [name]: value }))
  }

  return (
    <div>
      <form
        onSubmit={handleChangePasswod}
        className=" w-2/3 flex flex-col gap-5"
      >
        <div className=" w-full flex flex-col gap-2">
          <label className=" text-darkBlue">Current Password</label>
          <div className="w-full rounded-xl p-3 gap-2 border-[1px] border-blueButton flex ">
            <img src={lock} alt="" className="w-5" />
            <input
              name="currentPassword"
              onChange={handleInputChange}
              value={userData.currentPassword}
              type={showCurrent ? 'text' : 'password'}
              placeholder="Current Password"
              className=" w-11/12 focus:outline-none"
              required
            />
            <img
              src={showCurrent ? eye : eyel}
              onClick={() => setshowCurrent(!showCurrent)}
              alt=""
              className="w-5 cursor-pointer"
            />
          </div>
        </div>
        <div className=" w-full flex flex-col gap-2">
          <label className=" text-darkBlue">New Password</label>
          <div className="w-full rounded-xl p-3 gap-2 border-[1px] border-blueButton flex ">
            <img src={lock} alt="" className="w-5" />
            <input
              name="newPassword"
              onChange={handleInputChange}
              value={userData.newPassword}
              type={showNew ? 'text' : 'password'}
              placeholder="New Password"
              className=" w-11/12 focus:outline-none"
              required
            />
            <img
              src={showNew ? eye : eyel}
              onClick={() => setshowNew(!showNew)}
              alt=""
              className="w-5 cursor-pointer"
            />
          </div>
        </div>
        <div className=" w-full flex flex-col gap-2">
          <label className=" text-darkBlue">New Password Confirmation</label>
          <div className="w-full rounded-xl p-3 gap-2 border-[1px] border-blueButton flex ">
            <img src={lock} alt="" className="w-5" />
            <input
              name="newPassword_confirmation"
              onChange={handleInputChange}
              value={userData.newPassword_confirmation}
              type={showConfirmation ? 'text' : 'password'}
              placeholder="New Password Confirmation"
              className=" w-11/12 focus:outline-none"
              required
            />
            <img
              src={showConfirmation ? eye : eyel}
              onClick={() => setshowConfirmation(!showConfirmation)}
              alt=""
              className="w-5 cursor-pointer"
            />
          </div>
        </div>
        {error && (
          <div className=" w-full flex justify-center items-center  p-2">
            <div className=" bg-red/25 p-1 text-red rounded">{error}</div>
          </div>
        )}
        {success && (
          <div className=" w-full flex justify-center items-center  p-2">
            <div className=" bg-green/25 p-1 text-green rounded">{success}</div>
          </div>
        )}
        <button
          disabled={loading || error}
          className="disabled:bg-darkBlue/50 rounded-lg bg-blueButton text-white text-center p-4 w-full"
        >
          Change Password
        </button>
      </form>
    </div>
  )
}

export default Security
